/* ==========================================================================
   juizs-stamped.js — adapter tussen Stamped en het Juizs-theme (golf 5d, 30-09)
   Laadt alleen bij "Bron van reviews" = Stamped (layout/theme.liquid), vóór
   Stamped's widget.min.js. Is Stamped eerder klaar, dan verwerkt de start-
   ronde hieronder wat er al staat; alles is herhaalbaar (idempotent).

   1. TOEGANKELIJKHEID van Stamped-DOM. Stamped documenteert niets over a11y;
      gevonden in hun widget.min.js en de widget-HTML (30-09):
      · "Schrijf een review" / "Stel een vraag" zijn <span role=button> met een
        inline onkeydown die op élke toets reageert en return false geeft:
        Tab klapt het formulier open en de focus kan niet verder
        (toetsenbordval, WCAG 2.1.2). Klantfoto's idem met onkeyup.
        → inline handler weg; alleen Enter/Spatie activeren.
      · Carrouselpijlen zijn <div onClick> zonder rol of focus → knop + label.
      · Tabs (Reviews/Vragen) reageren alleen op klikken → ook Enter/Spatie.
      · Sterren per review: role=list zonder items, Engelse label →
        role=img met "4 van 5 sterren".
      · Engelse labels/placeholder → Nederlands (de pagina is lang="nl").
      · Fotomodal: bevat een <h1> (tweede h1 op de pagina) → <p>; na sluiten
        gaat de focus terug naar de foto waar je vandaan kwam.
      Stamped repareert zelf al de sterren in het reviewformulier (radio-
      groep) en de toetsen van de paginering: daar blijven we vanaf.
   2. NOOIT EEN LEEG VAK. Elementen met .jst-pending blijven onzichtbaar
      (wel opgemaakt: Stamped meet hoogtes) tot er echt reviews staan. Komt
      er niets — of faalt Stamped (adblocker, storing) — dan blijven ze weg.
   3. CATEGORIEKNOPPEN (juizs-reviews) en ADOPTIE: één echte review uit een
      verborgen Stamped-carrousel overnemen in onze eigen markup (galerij-
      slide op de PDP, reviewkaart in de bento). Alleen tekst, via
      textContent: nooit HTML van buiten in de pagina.
   ========================================================================== */
(function () {
  'use strict';
  if (window.JuizsStamped) return;

  var doc = document;
  var isNL = /^nl/i.test(doc.documentElement.getAttribute('lang') || 'nl');
  var WIDGETS = '#stamped-main-widget, #stamped-reviews-widget, .stamped-ugc-modal';

  var LABELS = {
    'Sort reviews': 'Reviews sorteren',
    'Sort reviews and ratings': 'Reviews sorteren',
    'Search reviews input': 'Zoeken in reviews',
    'Search Reviews': 'Zoeken in reviews',
    'Clear search input': 'Zoekveld leegmaken',
    'Reviews Pagination': 'Paginering van de reviews',
    'Previous page': 'Vorige pagina',
    'Next page': 'Volgende pagina',
    'First page': 'Eerste pagina',
    'Last page': 'Laatste pagina',
    'Questions': 'Vragen',
    'Close': 'Sluiten',
    'Previous Photo': 'Vorige foto',
    'Next Photo': 'Volgende foto',
    'Customer Review Photos': "Foto's bij de reviews",
    'Customer photos': "Foto's van klanten",
    'Customer Photos': "Foto's van klanten",
    'Link to Product': 'Naar het product',
    'Sort': 'Sorteren',
    'Photos': "Foto's",
    'Rate review as helpful': 'Nuttig',
    'Rate review as not helpful': 'Niet nuttig'
  };

  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
  function clean(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
  function textOf(el, sel) { var n = el && el.querySelector(sel); return n ? clean(n.textContent) : ''; }
  function isActivateKey(e) { return e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar'; }
  function starsLabel(n) {
    var v = Math.round(n * 10) / 10;
    return String(v).replace('.', isNL ? ',' : '.') + (isNL ? ' van 5 sterren' : ' out of 5 stars');
  }

  /* ---------- 1. Toegankelijkheid ---------- */

  /* Maakt een element bedienbaar als knop: focusbaar, rol, en alleen Enter of
     Spatie activeren (via click(), dus via Stamped's eigen onclick). */
  function makeOperable(el, label) {
    if (el.getAttribute('data-jst-key') === '1') return;
    el.setAttribute('data-jst-key', '1');
    var tag = el.tagName;
    var native = tag === 'BUTTON' || tag === 'INPUT' || tag === 'SELECT' || tag === 'TEXTAREA' || (tag === 'A' && el.hasAttribute('href'));
    if (!native) {
      if (!el.getAttribute('role')) el.setAttribute('role', 'button');
      var ti = el.getAttribute('tabindex');
      if (ti === null || ti === '') el.setAttribute('tabindex', '0');
    }
    if (label && !el.getAttribute('aria-label')) el.setAttribute('aria-label', label);
    el.addEventListener('keydown', function (e) {
      if (e.target !== el || !isActivateKey(e)) return;
      e.preventDefault();
      el.click();
    });
  }

  function translate(root) {
    if (!isNL) return;
    each(root.querySelectorAll('[aria-label]'), function (el) {
      var v = el.getAttribute('aria-label');
      if (LABELS[v]) el.setAttribute('aria-label', LABELS[v]);
      else if (/^Page \d+$/.test(v)) el.setAttribute('aria-label', v.replace('Page', 'Pagina'));
      else if (/^\d stars?$/.test(v)) el.setAttribute('aria-label', v.charAt(0) + (v.charAt(0) === '1' ? ' ster' : ' sterren'));
      else if (/^\d+ Rate review as (not )?helpful$/.test(v)) {
        /* Stamped zet het aantal stemmen vóór de actie ("0 Rate review as helpful") */
        var votes = v.split(' ')[0];
        el.setAttribute('aria-label', (v.indexOf('not helpful') > -1 ? 'Niet nuttig' : 'Nuttig') + ' (' + votes + ')');
      }
      else if (v.indexOf(' - Customer Photo From ') > -1) el.setAttribute('aria-label', v.replace(' - Customer Photo From ', ' — foto van '));
    });
    each(root.querySelectorAll('input[placeholder]'), function (el) {
      var v = el.getAttribute('placeholder');
      if (LABELS[v]) el.setAttribute('placeholder', LABELS[v]);
    });
    each(root.querySelectorAll('.stamped-photos-title, .stamped-sort-select option[value="featured"], .stamped-ugc-modal-user-source'), function (el) {
      var v = clean(el.textContent);
      if (LABELS[v]) el.textContent = LABELS[v];
    });
  }

  function fixWidget(root) {
    if (!root || !root.querySelectorAll) return;

    /* Inline toetshandlers die op élke toets reageren (Tab-val) */
    each(root.querySelectorAll('[onkeydown], [onkeyup]'), function (el) {
      if (el.closest('.stamped-starrating, .stamped-pagination')) return;
      el.removeAttribute('onkeydown');
      el.removeAttribute('onkeyup');
      el.onkeydown = null;
      el.onkeyup = null;
      makeOperable(el);
    });

    /* Rol "knop" zonder toetsenbord: tabs, sluitknop, zoekveld leegmaken … */
    each(root.querySelectorAll('[role="button"], [role="tab"]'), function (el) {
      if (el.closest('.stamped-starrating, .stamped-pagination, .stamped-ugc-modal-nav, .stamped-ugc-modal-list-photos')) return;
      makeOperable(el);
    });

    /* Carrouselpijlen */
    each(root.querySelectorAll('.stamped-carousel-button-left'), function (el) {
      makeOperable(el, isNL ? 'Vorige reviews' : 'Previous reviews');
    });
    each(root.querySelectorAll('.stamped-carousel-button-right'), function (el) {
      makeOperable(el, isNL ? 'Volgende reviews' : 'Next reviews');
    });

    /* Sterren per review (niet die in het formulier: die doet Stamped zelf) */
    each(root.querySelectorAll('.stamped-review-header-starratings[data-rating]'), function (el) {
      var r = parseFloat(String(el.getAttribute('data-rating')).replace(',', '.'));
      if (isNaN(r)) return;
      el.setAttribute('role', 'img');
      el.setAttribute('aria-label', starsLabel(r));
    });
    each(root.querySelectorAll('.stamped-reviews-rating'), function (el) {
      el.setAttribute('role', 'img');
      el.setAttribute('aria-label', starsLabel(el.querySelectorAll('.stamped-fa-star').length));
    });

    translate(root);
  }

  /* Fotomodal: tweede <h1> weg, labels NL, focus terug na sluiten */
  var lastFocus = null;
  var modalTrigger = null;
  var modalObserver = null;
  doc.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('#stamped-main-widget, #stamped-reviews-widget')) lastFocus = t;
  }, true);

  function fixModal() {
    var modal = doc.querySelector('.stamped-ugc-modal');
    if (!modal) return;
    each(modal.querySelectorAll('h1'), function (h) {
      var p = doc.createElement('p');
      p.className = h.className;
      while (h.firstChild) p.appendChild(h.firstChild);
      h.parentNode.replaceChild(p, h);
    });
    fixWidget(modal);
    if (!modalObserver && window.MutationObserver) {
      modalTrigger = lastFocus;
      modalObserver = new MutationObserver(function () {
        if (doc.querySelector('.stamped-ugc-modal')) return;
        modalObserver.disconnect();
        modalObserver = null;
        if (modalTrigger && doc.contains(modalTrigger)) modalTrigger.focus();
        modalTrigger = null;
      });
      modalObserver.observe(doc.body, { childList: true });
    }
  }

  /* ---------- 2. Zichtbaarheid: nooit een leeg vak ---------- */

  function reveal(el) {
    if (!el) return;
    el.classList.remove('jst-pending');
    el.removeAttribute('aria-busy');
  }
  /* Stamped zet data-lang op een weergavewidget zodra die getekend is */
  function isRendered(w) { return !!w && w.hasAttribute('data-lang'); }
  function hasReviews(w) { return w.style.display !== 'none' && !!w.querySelector('.block'); }

  function updateMain() {
    each(doc.querySelectorAll('[data-jst-slot="main"]'), function (slot) {
      var w = slot.querySelector('#stamped-main-widget');
      if (!w || !w.children.length) return;
      reveal(slot);
      reveal(slot.closest('[data-jst-reveal]'));
    });
  }

  function updateCarousels() {
    each(doc.querySelectorAll('[data-jst-slot="carousel"]'), function (slot) {
      var w = slot.querySelector('#stamped-reviews-widget');
      if (!isRendered(w)) return;
      slot.removeAttribute('aria-busy');
      var section = slot.closest('[data-jst-reveal]');
      var scope = section || slot.parentNode;
      var emptyEl = scope.querySelector('[data-jst-empty]');
      var pressed = scope.querySelector('[data-jst-cat][aria-pressed="true"]');
      var isAll = !pressed || pressed.hasAttribute('data-jst-cat-all');
      if (hasReviews(w)) {
        reveal(slot);
        reveal(section);
        if (emptyEl) emptyEl.textContent = '';
      } else {
        /* Leeg: vak dicht. Bij een categorie een korte melding; is de hele
           collectie leeg, dan blijft een nog verborgen sectie verborgen. */
        slot.classList.add('jst-pending');
        if (emptyEl) emptyEl.textContent = isAll ? '' : (emptyEl.getAttribute('data-jst-empty-text') || '');
      }
    });
  }

  /* ---------- 3a. Adoptie: één echte review in onze eigen markup ---------- */

  function pickReview(w, maxLen) {
    var first = null;
    var short = null;
    each(w.querySelectorAll('.block'), function (b) {
      var text = textOf(b, '.stamped-reviews-message-block');
      if (!text) return;
      var r = {
        text: text,
        name: textOf(b, '.stamped-reviews-author'),
        product: textOf(b, '.stamped-reviews-product-title'),
        stars: b.querySelectorAll('.stamped-reviews-rating .stamped-fa-star').length
      };
      if (!first) first = r;
      if (!short && text.length <= maxLen) short = r;
    });
    /* Stamped-volgorde (best beoordeeld, min-rating) blijft leidend; liever
       een korte die heel past dan een lange die wordt afgekapt */
    return short || first;
  }

  function setField(slot, name, value) {
    each(slot.querySelectorAll('[data-jst-field="' + name + '"]'), function (el) {
      var v = value || '';
      if (v && el.hasAttribute('data-jst-quote')) v = '“' + v + '”';
      el.textContent = v;
      if (el.hasAttribute('data-jst-optional')) el.hidden = !v;
    });
  }

  function updateAdopt() {
    each(doc.querySelectorAll('[data-jst-adopt]:not([data-jst-done])'), function (slot) {
      var w = slot.querySelector('#stamped-reviews-widget');
      if (!isRendered(w)) return;
      slot.setAttribute('data-jst-done', '1');
      var r = hasReviews(w) ? pickReview(w, parseInt(slot.getAttribute('data-jst-maxlen'), 10) || 240) : null;
      /* De bron is klaar: weg ermee, zodat hij niet meeherlaadt en geen
         verborgen links achterlaat */
      var source = slot.querySelector('[data-jst-source]');
      if (source && source.parentNode) source.parentNode.removeChild(source);
      if (!r) return; /* niets echts → blijft verborgen */

      var n = Math.max(0, Math.min(5, r.stars));
      setField(slot, 'text', r.text);
      setField(slot, 'name', r.name);
      setField(slot, 'product', r.product);
      setField(slot, 'initials', clean(r.name).replace(/[^A-Za-zÀ-ÿ]/g, '').slice(0, 2).toUpperCase());
      setField(slot, 'stars', n ? '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n) : '');
      setField(slot, 'stars-label', n ? starsLabel(n) : '');
      reveal(slot);

      /* Galerij: het bijbehorende miniatuur-tabje tonen */
      if (slot.id) {
        each(doc.querySelectorAll('[aria-controls="' + slot.id + '"][data-jst-thumb]'), function (thumb) {
          thumb.hidden = false;
        });
      }
    });
  }

  /* ---------- 3b. Categorieknoppen (juizs-reviews) ---------- */

  function initCategories(scope) {
    each((scope || doc).querySelectorAll('[data-jst-cats]:not([data-jst-init])'), function (group) {
      group.setAttribute('data-jst-init', '1');
      var section = group.closest('[data-jst-reveal]') || group.parentNode;
      var buttons = group.querySelectorAll('[data-jst-cat]');
      each(buttons, function (btn) {
        btn.addEventListener('click', function () {
          if (btn.getAttribute('aria-pressed') === 'true') return;
          var slot = section.querySelector('[data-jst-slot="carousel"]');
          var w = slot && slot.querySelector('#stamped-reviews-widget');
          if (!w) return;
          each(buttons, function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          var ids = btn.getAttribute('data-product-ids') || '';
          if (ids) w.setAttribute('data-product-ids', ids);
          else w.removeAttribute('data-product-ids');
          /* Opnieuw laten tekenen: data-lang weg = "nog niet klaar"; een eerder
             lege widget heeft van Stamped display:none gekregen */
          w.removeAttribute('data-lang');
          w.removeAttribute('data-page');
          w.style.display = '';
          slot.setAttribute('aria-busy', 'true');
          var emptyEl = section.querySelector('[data-jst-empty]');
          if (emptyEl) emptyEl.textContent = '';
          if (window.StampedFn && typeof window.StampedFn.loadDisplayWidgets === 'function') {
            window.StampedFn.loadDisplayWidgets();
          }
        });
      });
    });
  }

  /* ---------- Samen ---------- */

  function refresh(scope) {
    initCategories(scope || doc);
    each(doc.querySelectorAll(WIDGETS), fixWidget);
    updateMain();
    updateCarousels();
    updateAdopt();
  }
  /* Stamped vuurt zijn events vóór zijn eigen a11y-nabewerking; één tik later
     staan zijn wijzigingen er al en overschrijven we ze niet dubbel */
  function later(fn) { return function () { setTimeout(fn, 0); }; }

  doc.addEventListener('stamped:reviews:loaded', later(refresh));
  doc.addEventListener('stamped:reviews:widget:loaded', later(refresh));
  doc.addEventListener('stamped:ugcmodal:open', later(fixModal));
  doc.addEventListener('stamped:ugcmodal:paged', later(fixModal));

  /* Theme editor: een opnieuw gerenderde sectie opnieuw laten vullen */
  doc.addEventListener('shopify:section:load', function (e) {
    var sec = e.target;
    initCategories(sec);
    var fn = window.StampedFn;
    if (!fn) return;
    if (sec.querySelector('#stamped-main-widget') && typeof fn.loadWidget === 'function') fn.loadWidget(true);
    if (sec.querySelector('#stamped-reviews-widget') && typeof fn.loadDisplayWidgets === 'function') fn.loadDisplayWidgets();
  });

  window.JuizsStamped = { refresh: refresh };
  refresh(doc);
})();
